// https://stackoverflow.com/questions/35623656/how-can-i-display-a-modal-dialog-in-redux-that-performs-asynchronous-actions/35641680#35641680

const types = {
  SHOW: 'schooladmin/modal/SHOW',
  HIDE: 'schooladmin/modal/HIDE',
  UPDATE: 'schooladmin/modal/UPDATE',
  HIDE_ALL: 'schooladmin/modal/HIDE_ALL'
};

const initialState = {
  stack: []
};

function modal(state = initialState, action) {
  const {stack} = state;
  switch (action.type) {

    case types.SHOW:
      const {modalType, modalProps} = action;
      return {stack: [{modalType, modalProps}, ...stack],};

    case types.HIDE:
      return {stack: stack.slice(1)};

    case types.HIDE_ALL:
      return {stack: []};

    case types.UPDATE:
      if (stack.length) {
        const {updateProps} = action;
        const {modalType, modalProps} = stack[0];
        return {
          stack: [
            {modalType, modalProps: {...modalProps, ...updateProps}},
            ...stack.slice(1)]
        }
      } else {
        return state;
      }

    default:
      return state;
  }
}

function show(modalType, modalProps = {}) {
  return {type: types.SHOW, modalType, modalProps};
}

function hide() {
  return {type: types.HIDE};
}

function update(updateProps) {
  return {type: types.UPDATE, updateProps};
}

function hide_all() {
  return {type: types.HIDE_ALL}
}

export default {
  name: 'modals',
  reducer: modal,
  actions: {
    ...types,
    show,
    hide,
    update,
    hide_all
  }
};
